import { Draggable } from '@hello-pangea/dnd';

import Icon from 'components/shared/Icon/Icon';

const SpecialtyItem = ({ specialty, index, onAction, actionIcon, actionColor, draggableIdPrefix = '' }) => {
  const draggableId = draggableIdPrefix ? `${draggableIdPrefix}-${specialty.value}` : String(specialty.value);
  
  return (
    <Draggable key={specialty.value} draggableId={draggableId} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style
          }}
          className={`flex mx-4 gap-2 h-8 flex-shrink-0 items-center ${snapshot.isDragging ? 'bg-white rounded-md shadow-md' : ''}`}
        >
          <div
            {...provided.dragHandleProps}
            className='cursor-grab p-1 active:cursor-grabbing'
          >
            <Icon
              icon='drag-drop-linear'
              className='cursor-grab active:cursor-grabbing'
            />
          </div>
          <div className='flex-1'>
            <span className='block max-w-[255px] truncate text-sm'>
              {specialty?.label}
            </span>
          </div>
          <Icon 
            icon={actionIcon}
            color={actionColor}
            onClick={() => onAction(specialty.value)}
            className='cursor-pointer'
          />
        </div>
      )}
    </Draggable>
  );
};

export default SpecialtyItem;
